import { shape, string } from 'prop-types';

export default shape({
  bus: shape({
    id: string,
  }),
  number: string,
});
